import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconPlusFusion = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-plus-fusion_svg__a)"
      d="M15.063 4.938c.28.25.437.593.437.968v4.188c0 .375-.156.75-.469 1.031l-3.969 3.969a1.368 1.368 0 0 1-1 .406H5.875c-.344 0-.719-.125-1-.438L.906 11.095a1.368 1.368 0 0 1-.406-1V5.906c0-.375.125-.718.406-.968l4-4C5.156.655 5.531.5 5.875.5h4.219c.344 0 .719.156 1 .438l3.969 4ZM10.968 8.75c.437 0 .75-.313.656-.75 0-.406-.313-.75-.719-.75h-2.25V5c0-.406-.312-.75-.719-.75a.76.76 0 0 0-.75.75v2.25H4.97a.74.74 0 0 0-.75.75c0 .438.343.75.75.75H7.25V11c0 .438.313.75.75.75a.734.734 0 0 0 .719-.75V8.75h2.25Z"
    />
    <defs>
      <linearGradient
        id="icon-plus-fusion_svg__a"
        x1={16}
        x2={0}
        y1={0}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconPlusFusion;
